import * as React from 'react'
import { Slot } from '@radix-ui/react-slot'
import { cn } from '@/lib/utils'
import { cva } from 'class-variance-authority'

type ResponsiveTextProps = {
  children: React.ReactNode
  className?: string
  asChild?: boolean
}

export const JumboText = ({ children, className, asChild }: ResponsiveTextProps): React.ReactElement => {
  const Comp = asChild ? Slot : 'h1'

  return (
    <Comp
      className={`text-[3rem] leading-[3.45rem] tracking-[0.03rem] md:text-[5rem] md:leading-[6.5rem] md:tracking-[0.05rem] ${className}`}
    >
      {children}
    </Comp>
  )
}

export const DisplayText = ({ children, className, asChild }: ResponsiveTextProps): React.ReactElement => {
  const Comp = asChild ? Slot : 'h2'

  return (
    <Comp
      className={`text-[2rem] leading-[2.3rem] tracking-[0.02rem] md:text-[3rem] md:leading-[3.3rem] md:tracking-[0.03rem] ${className}`}
    >
      {children}
    </Comp>
  )
}

export const HeadlineText = ({ children, className, asChild }: ResponsiveTextProps): React.ReactElement => {
  const Comp = asChild ? Slot : 'h5'

  return (
    <Comp
      className={`text-[1.25rem] leading-[1.625rem] tracking-[0.0125rem] md:text-[1.75rem] md:leading-[2.275rem] md:tracking-[0.0175rem] ${className}`}
    >
      {children}
    </Comp>
  )
}

export const BodyText = ({ children, className, asChild }: ResponsiveTextProps): React.ReactElement => {
  const Comp = asChild ? Slot : 'p'

  return <Comp className={`text-[1rem] leading-[1.3rem] tracking-[0.03rem] ${className}`}>{children}</Comp>
}

export const detailTextStyle = cva('text-[0.75rem] leading-[0.975rem] tracking-[0.0225rem]')
export const DetailText = ({ children, className, asChild }: ResponsiveTextProps): React.ReactElement => {
  const Comp = asChild ? Slot : 'p'

  return <Comp className={cn(detailTextStyle(), className)}>{children}</Comp>
}
